import { DateTime } from 'luxon'

export function isFilialWorkingTime (filial) {
  if (filial.startTime && filial.endTime && filial?.region?.timeZone) {
    const openTime = DateTime.fromFormat(filial.startTime, 'HH:mm', { zone: filial?.region?.timeZone })
    const closeTime = DateTime.fromFormat(filial.endTime, 'HH:mm', { zone: filial?.region?.timeZone })
    const filialTime = DateTime.now().setZone(filial?.region?.timeZone)

    // console.log(`${filial.name} (ID ${filial.id}, TimeZone ${filial?.region?.timeZone}) local time ${filialTime.toFormat('HH:mm')}`)

    return filialTime.toMillis() >= openTime.toMillis() && filialTime.toMillis() < closeTime.toMillis()
  }

  return true
}

export function getFilialSettingValue (settings, key) {
  const row = (settings || []).find((s) => s.key === key)

  if (!row) {
    return null
  }

  return row.isDefaultValue ? row.defaultValue : row.value
}
